import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Image, Container} from "react-bootstrap";
import background from "./background.jpg";
export const Name = () => {
	return (
		<div className='name'>
			<br />
			<br />
			<br />
			<br />
			<p className="first-line">Hi, my name is </p>
			<h1 className="second-line">Musa.</h1>
			<h1 className="third-line">I am a Graduate Software Developer</h1>
			<p className="fourth-line">with experience in Javascript and Javascript frameworks.</p>
		</div>
	);
};
